var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[(!_vm.isSidebarHidden)?_c('SidebarLayout',{on:{"is-sidebar-open":_vm.onSidebarStateChange}}):_vm._e(),_c('div',{staticClass:"main-layout-container",class:{ 'sidebar-open': _vm.isSidebarOpen }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }